'use client'

import WorkCollection from '@/features/veluvit/components/collection/work-collection'
import DetailBox from '@/features/veluvit/components/detail/detail-box'
import { useCatalogMedia } from '@/features/veluvit/hooks/use-app-data'
import { gridItems, workFor } from '@/features/veluvit/lib/rules'

/**
 * 상세 › 컬렉션 — 장소 → 장면(work-collection). 작품 소개 바로 아래.
 * 2026-10-07 스토리 앨범(장소마다 앨범 한 권 · 시트로 열기)과 컬렉션 페이지를 합쳐 이 섹션 하나로 — 장소가 묶음 제목, 장면 카드가 가로로.
 * 모바일은 가로 줄을 화면 끝까지 밀어 스크롤 끝이 잘리지 않게, PC 는 컬럼 안에서.
 */
export default function CollectionBox({ id }: { id: string }) {
  const { catalog } = useCatalogMedia()
  // 장면 카드도 들어갈 장면도 없는 작품은 섹션째 숨긴다(제목만 남지 않게)
  if (!gridItems(catalog, id).length && !workFor(catalog, id)?.branches?.length)
    return null
  return (
    <DetailBox title="컬렉션">
      <div className="mt-3">
        <WorkCollection
          workId={id}
          rowClassName="-mx-4 px-4 over10:mx-0 over10:px-0"
        />
      </div>
    </DetailBox>
  )
}
